import { Handler } from "../common/handler";
import "../styles/styles.css";
import UpNote from "../assets/icons/up-note.svg"
import DownNote from "../assets/icons/down-note.svg"
import DeleteNote from "../assets/icons/delete-note.svg"

export function NoteActionButton({
  downAction,
  upAction,
  deleteAction: deleteAction,
}: {
  downAction: () => void;
  upAction: () => void;
  deleteAction: () => void;
}) {
  const DownButton = () => {
    return (
      <button className="bottom-action-button" onClick={downAction}>
        <img src={DownNote} style={{transform: "scaleY(-1)"}}/>
      </button>
    );
  };
  const UpButton = () => {
    return (
      <button className="bottom-action-button" onClick={upAction}>
        <img src={UpNote} />
      </button>
    );
  };
  const DeleteButton = () => {
    return (
      <button className="bottom-action-button" onClick={deleteAction}>
        <img src={DeleteNote} />
      </button>
    );
  };
  return (
    <div className="note-action-buttons">
      <DownButton />
      <UpButton />
      <DeleteButton />
    </div>
  );
}
